import { Action, createReducer, on } from '@ngrx/store';
import { IGenericError, ErrorResponse } from 'src/app/core/models/generic-models';
import {
  loadLegalDocumentsPrevious,
  loadLegalDocumentsPreviousSuccess,
  loadLegalDocumentsPreviousFailure
} from '../actions/legal-documents.actions';
import { ILegalDocumentsResponse } from '../models/legal-documents.model';
import * as actions from '../actions';

export const previousLegalDocumentsFeatureKey = 'previousLegalDocuments';

export interface PreviousLegalDocumentsState {
  loadLegalDocumentsPrevious: any;
  loadLegalDocumentsPreviousSuccess: ILegalDocumentsResponse[];
  loadLegalDocumentsPreviousFailure: IGenericError<ErrorResponse>;
}

export const initialState: PreviousLegalDocumentsState = {
  loadLegalDocumentsPrevious: undefined,
  loadLegalDocumentsPreviousSuccess: undefined,
  loadLegalDocumentsPreviousFailure: undefined
};

export const reducer = createReducer(
  initialState,

  on(actions.loadLegalDocumentsPrevious, (state, action) => ({
    ...state,
    loadLegalDocumentsPrevious: action.request
  })),
  on(actions.loadLegalDocumentsPreviousSuccess, (state, action) => ({
    ...state,
    loadLegalDocumentsPreviousSuccess: action.response
  })),
  on(actions.loadLegalDocumentsPreviousFailure, (state, action) => ({
    ...state,
    loadLegalDocumentsPreviousFailure: action.error
  }))
);

export const getPreviousLegalDocumentsRequest = (state: PreviousLegalDocumentsState) => state.loadLegalDocumentsPrevious;
export const getPreviousLegalDocumentsResponse = (state: PreviousLegalDocumentsState) => {
  return state.loadLegalDocumentsPreviousSuccess;
};
export const getPreviousLegalDocumentsFailure = (state: PreviousLegalDocumentsState) => state.loadLegalDocumentsPreviousFailure;
